import {component, dateField, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {AddressData} from "../../address/address.data";

export class SupplierData extends LocalisableEntityData<SupplierData> {
    @identifier vendorId: number;
    @field name: string;
    @field description: string;
    @field telephone1: string;
    @field telephone2: string;
    @field fax: string;
    @field code: string;
    @field rebatePercent: number;
    @field generateCsv: boolean;
    @field status: string;
    @dateField startDate: Date;
    @field email: string;
    @field discontinued: boolean;
    @component address1: AddressData;
    @component address2: AddressData;
}
